import { EntityRepositoryBase } from './entityRepositoryBase';

/**
 * EntityPubNotNullType
 */
export type EntityPubNotNullType<JP> = {
  /** 送信者ID */
  sendId: string,
  /** 送信元ID */
  replyId: string,
  /** データ */
  data: JP,
}

/**
 * EntityDataPubNotNullType
 */
export type EntityDataPubNotNullType<J, JP> = {
  /** データ */
  data: J,
  /** 公開 */
  pub: EntityPubNotNullType<JP>,
}

/**
 * 外部通信用のEntityの抽象クラス.
 * AppとEntityを共有する場合に使用する.
 */
export abstract class EntityPub<P, J, PP, JP> extends EntityRepositoryBase<P, J, PP, JP> {
  constructor(_value: P, _valuePub: EntityPubNotNullType<PP>) {
    super(_value, _valuePub);
    this._valuePubData = Object.freeze(_valuePub);
  }

  /**
   * Pubデータ取得
   */
  abstract toJsonPubData(): JP

  /**
   * Pub json取得
   * @returns pub json
   */
  toJsonPub(): EntityPubNotNullType<JP> {
    return {
      sendId: this._valuePubData.sendId,
      replyId: this._valuePubData.replyId,
      data: this.toJsonPubData(),
    };
  }

  /**
   * Json取得
   * @returns json
   */
  toJson(): EntityDataPubNotNullType<J, JP> {
    return {
      data: this.toJsonData(),
      pub: this.toJsonPub(),
    };
  }

  /**
   * pub取得
   */
  get pub(): EntityPubNotNullType<string> {
    const p = this.toJsonPub();
    return {
      sendId: p.sendId,
      replyId: p.replyId,
      data: JSON.stringify(p.data),
    };
  }

  /**
   * pubのデータ
   */
  protected readonly _valuePubData: EntityPubNotNullType<PP>;
}
